import { FishCatchesIcon } from '../../../Icons/FishCatchesIcon';
import { Text } from '../../../Text/Text';

export const PostImagePlaceholder = () => {
  return (
    <section className="bg-twilight flex size-full flex-wrap content-center justify-center">
      <FishCatchesIcon className="text-lake-fog w-full" size={160} title="fish catches icon" />
      <Text className="text-sea-foam font-semibold">No photo added</Text>
    </section>
  );
};
